/**
 * PrintingShowActions component
 * Provides actions for the PrintingShow view:
 * - EVENTS button: Navigate to filtered events list for this printing
 * - Edit button: Standard React Admin edit action
 */

import { TopToolbar, EditButton, useRecordContext } from 'react-admin';
import { Button } from '@mui/material';
import { List as ListIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Printing } from '../../types';

export const PrintingShowActions = () => {
  const record = useRecordContext<Printing>();
  const navigate = useNavigate();

  if (!record) {
    return null;
  }

  const handleEventsClick = () => {
    // Navigate to events list filtered by printingId
    navigate({
      pathname: '/events',
      search: `?filter=${encodeURIComponent(JSON.stringify({ printingId: record.id }))}`,
    });
  };

  return (
    <TopToolbar>
      <Button
        startIcon={<ListIcon />}
        onClick={handleEventsClick}
        size="small"
        color="primary"
        sx={{ ml: 1 }}
      >
        EVENTS
      </Button>
      <EditButton sx={{ ml: 1 }} />
    </TopToolbar>
  );
};
